import src from "IMAGE";
export default { src, width: 267, height: 267, blurWidth: 0, blurHeight: 0};
